export enum ChartShowType {
    dashboard = 'dashboard',
    report = 'report',
}
